import { isMac } from '@shared/utils/platform'

/** The macOS major version (15, 26, …), or 0 off macOS or where the preload doesn't report it (browser builds). */
const macOSMajorVersion = isMac ? Number.parseInt(window.highlight?.systemVersion ?? '', 10) || 0 : 0

/** macOS 26 (Tahoe) redrew the window controls: gradient fills and new glyphs. */
export const hasTahoeWindowControls = macOSMajorVersion >= 26
